// Parley Serené Mundial 2026 — JS frontend
// - Countdown
// - Validate order (POST {BACKEND_URL}/validate)
// - Render predictions form
// - Submit predictions (POST {BACKEND_URL}/submit)
// - Success state
// SECURITY: validation/cierre real es server-side. Esto solo es UX.

(function () {
  'use strict';

  // ============================================================
  // Config
  // ============================================================
  // Backend público: el Dev Dashboard nuevo no ofrece App Proxy para Custom Apps.
  // Seguridad: CORS estricto + Origin check + rate limit en el backend.
  var BACKEND_URL = 'https://parley-mundial-backend.vercel.app/api';
  var GENERIC_ERROR = 'No pudimos validar tu pedido con los datos ingresados. Revisa que el número de pedido y el email (o celular) sean los mismos registrados en tu compra.';

  // ============================================================
  // Helpers
  // ============================================================
  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function showError(formEl, msg) {
    var el = $('[data-error]', formEl);
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }
  function clearError(formEl) {
    var el = $('[data-error]', formEl);
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
  }

  function fmtMoney(amount, currency) {
    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: currency || 'COP',
        maximumFractionDigits: 0,
      }).format(amount);
    } catch (e) {
      return amount + ' ' + (currency || '');
    }
  }

  function track(name, payload) {
    try {
      if (window.dataLayer) window.dataLayer.push({ event: name, ...payload });
      if (window.gtag) window.gtag('event', name, payload || {});
      if (window.fbq) window.fbq('trackCustom', name, payload || {});
    } catch (e) { /* noop */ }
  }

  // ============================================================
  // Countdown
  // ============================================================
  function startCountdown(closeAt) {
    var wrapper = $('[data-parley-countdown]');
    if (!wrapper || !closeAt) return;
    var target = new Date(closeAt).getTime();
    if (isNaN(target)) return;

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        $('[data-cd-dd]', wrapper).textContent = '00';
        $('[data-cd-hh]', wrapper).textContent = '00';
        $('[data-cd-mm]', wrapper).textContent = '00';
        $('[data-cd-ss]', wrapper).textContent = '00';
        clearInterval(timer);
        return;
      }
      var dd = Math.floor(diff / 86400000);
      var hh = Math.floor((diff % 86400000) / 3600000);
      var mm = Math.floor((diff % 3600000) / 60000);
      var ss = Math.floor((diff % 60000) / 1000);
      $('[data-cd-dd]', wrapper).textContent = String(dd).padStart(2, '0');
      $('[data-cd-hh]', wrapper).textContent = String(hh).padStart(2, '0');
      $('[data-cd-mm]', wrapper).textContent = String(mm).padStart(2, '0');
      $('[data-cd-ss]', wrapper).textContent = String(ss).padStart(2, '0');
    }
    tick();
    var timer = setInterval(tick, 1000);
  }

  // ============================================================
  // Fetch parley status on load (for countdown)
  // ============================================================
  function bootstrap() {
    var validator = $('[data-parley-id]');
    if (!validator) return;
    var parleyId = validator.getAttribute('data-parley-id');
    if (!parleyId) return;

    fetch(BACKEND_URL + '/status?parley_id=' + encodeURIComponent(parleyId))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        if (data.close_at) startCountdown(data.close_at);
      })
      .catch(function () { /* silent */ });

    track('parley_page_view', { parley_id: parleyId });
  }

  // ============================================================
  // Step 1: Validate order
  // ============================================================
  var state = {
    token: null,
    order: null,
    parley: null,
  };

  function handleValidate(e) {
    e.preventDefault();
    var form = e.currentTarget;
    clearError(form);

    var orderInput = form.elements['order_number'];
    var emailInput = form.elements['email'];
    var phoneInput = form.elements['phone'];
    var orderNumber = (orderInput.value || '').trim();
    var email = emailInput ? (emailInput.value || '').trim() : '';
    var phone = phoneInput ? (phoneInput.value || '').trim() : '';

    // order_number obligatorio + al menos uno de (email, phone)
    if (!orderNumber) {
      showError(form, 'Ingresa el número de pedido.');
      return;
    }
    if (!email && !phone) {
      showError(form, 'Ingresa el email registrado en tu compra (o tu celular).');
      return;
    }

    var section = form.closest('[data-parley-id]');
    var parleyId = section ? section.getAttribute('data-parley-id') : null;

    var btn = $('button[type="submit"]', form);
    btn.disabled = true;
    btn.textContent = 'Validando…';

    track('order_validation_started', { parley_id: parleyId });

    // Body: solo enviamos campos no vacíos para no triggear validaciones server-side innecesarias
    var payload = { order_number: orderNumber, parley_id: parleyId };
    if (email) payload.email = email;
    if (phone) payload.phone = phone;

    fetch(BACKEND_URL + '/validate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        btn.disabled = false;
        btn.textContent = 'Validar mi compra';
        if (!res.json.valid) {
          showError(form, res.json.message || GENERIC_ERROR);
          track('order_validation_failed', { parley_id: parleyId, error_code: res.json.error_code });
          return;
        }
        state.token = res.json.token;
        state.order = res.json.order;
        state.parley = res.json.parley;
        // Guardamos email + phone en memoria para auditoría en submit
        state.emailInput = email;
        state.phoneInput = phone;
        track('order_validation_success', { parley_id: parleyId, order_number: res.json.order.order_number });
        renderPredictionStep();
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'Validar mi compra';
        showError(form, 'No pudimos contactar el servidor. Intenta de nuevo.');
        console.error(err);
      });
  }

  // ============================================================
  // Step 2: Render prediction form
  // ============================================================
  function renderPredictionStep() {
    var validateStep = $('[data-step="validate"]');
    var predictStep = $('[data-step="predict"]');
    if (validateStep) validateStep.hidden = true;
    if (predictStep) predictStep.hidden = false;

    // Summary
    var summary = $('[data-order-summary]', predictStep);
    if (summary) {
      summary.innerHTML =
        'Pedido <strong>' + state.order.order_number + '</strong>' +
        (state.order.customer_name ? ' · ' + escapeHtml(state.order.customer_name) : '') +
        ' · Total <strong>' + fmtMoney(state.order.order_total, state.order.currency) + '</strong>';
    }

    // Matches
    var matchesEl = $('[data-matches]', predictStep);
    var tpl = $('#parley-match-template');
    if (matchesEl && tpl) {
      matchesEl.innerHTML = '';
      state.parley.matches
        .slice()
        .sort(function (a, b) { return a.order_index - b.order_index; })
        .forEach(function (m, idx) {
          var clone = tpl.content.cloneNode(true);
          $('.parley-match__num', clone).textContent = (idx + 1);
          $('[data-home-emoji]', clone).textContent = m.home_emoji || '';
          $('[data-home-name]', clone).textContent = m.home_team;
          $('[data-away-emoji]', clone).textContent = m.away_emoji || '';
          $('[data-away-name]', clone).textContent = m.away_team;
          $('[data-home-score]', clone).setAttribute('data-match-id', m.match_id);
          $('[data-home-score]', clone).setAttribute('data-side', 'home');
          $('[data-away-score]', clone).setAttribute('data-match-id', m.match_id);
          $('[data-away-score]', clone).setAttribute('data-side', 'away');
          if (m.kickoff_at) {
            var kk = new Date(m.kickoff_at);
            if (!isNaN(kk.getTime())) {
              $('[data-kickoff]', clone).textContent = kk.toLocaleString('es-CO', {
                weekday: 'short', day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
              });
            }
          }
          matchesEl.appendChild(clone);
        });
    }

    var form = $('[data-form="predict"]');
    if (form) form.addEventListener('submit', handleSubmit);

    track('prediction_form_viewed', {
      parley_id: state.parley.parley_id,
      order_number: state.order.order_number,
    });

    // Scroll to predict step
    predictStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ============================================================
  // Step 2b: Submit predictions
  // ============================================================
  function handleSubmit(e) {
    e.preventDefault();
    var form = e.currentTarget;
    clearError(form);

    if (!form.elements['terms_accepted'].checked) {
      showError(form, 'Debes aceptar los términos y condiciones.');
      return;
    }

    // Recolectar marcadores
    var predictions = [];
    var ok = true;
    var matchEls = $$('.parley-match', form);
    matchEls.forEach(function (matchEl) {
      var homeInput = $('[data-home-score]', matchEl);
      var awayInput = $('[data-away-score]', matchEl);
      var hs = parseInt(homeInput.value, 10);
      var as = parseInt(awayInput.value, 10);
      if (!Number.isFinite(hs) || !Number.isFinite(as) || hs < 0 || as < 0 || hs > 20 || as > 20) {
        ok = false;
      }
      predictions.push({
        match_id: homeInput.getAttribute('data-match-id'),
        home_score: hs,
        away_score: as,
      });
    });

    if (!ok || predictions.length !== 10) {
      showError(form, 'Completa los 10 marcadores con números entre 0 y 20.');
      return;
    }

    // Confirmación
    if (!window.confirm('Estás a punto de registrar tus marcadores para el pedido ' + state.order.order_number + '. No podrás modificarlos después de enviarlos.')) {
      return;
    }

    var btn = $('[data-submit-btn]', form);
    btn.disabled = true;
    btn.textContent = 'Enviando…';

    var submitPayload = {
      token: state.token,
      predictions: predictions,
      terms_accepted: true,
      marketing_consent: form.elements['marketing_consent'].checked,
    };
    if (state.emailInput) submitPayload.email = state.emailInput;
    if (state.phoneInput) submitPayload.phone = state.phoneInput;

    fetch(BACKEND_URL + '/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(submitPayload),
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        btn.disabled = false;
        btn.textContent = 'Enviar mis marcadores';
        if (!res.json.success) {
          showError(form, res.json.message || 'No pudimos registrar tu participación.');
          return;
        }
        track('predictions_submitted', {
          parley_id: state.parley.parley_id,
          order_number: state.order.order_number,
        });
        showSuccess(res.json.participation_id);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'Enviar mis marcadores';
        showError(form, 'No pudimos contactar el servidor. Intenta de nuevo.');
        console.error(err);
      });
  }

  // ============================================================
  // Step 3: Success
  // ============================================================
  function showSuccess(participationId) {
    var predictStep = $('[data-step="predict"]');
    var successStep = $('[data-step="success"]');
    if (predictStep) predictStep.hidden = true;
    if (successStep) successStep.hidden = false;
    var idEl = $('[data-success-id]', successStep);
    if (idEl) idEl.textContent = 'Participación ' + (participationId || '').slice(0, 8);

    // Share
    var shareBtn = $('[data-share-btn]', successStep);
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = window.location.href;
        var text = 'Estoy jugando el Parley Serené Mundial 2026 — predigo marcadores y gano bonos en cada compra.';
        if (navigator.share) {
          navigator.share({ title: 'Parley Serené Mundial 2026', text: text, url: url }).catch(function () {});
        } else {
          navigator.clipboard.writeText(url + '\n\n' + text).then(function () {
            shareBtn.textContent = '¡Enlace copiado!';
            setTimeout(function () { shareBtn.textContent = 'Compartir'; }, 2000);
          });
        }
      });
    }

    successStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
    track('participation_confirmed', {
      parley_id: state.parley.parley_id,
      order_number: state.order.order_number,
    });
  }

  // ============================================================
  // Utils
  // ============================================================
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ============================================================
  // Mis Marcadores — consultar predicciones registradas
  // ============================================================
  function initMisMarcadores() {
    var form = $('[data-form="consultar-marcadores"]');
    if (!form) return;
    var section = form.closest('[data-parley-id]');
    var parleyId = section ? section.getAttribute('data-parley-id') : null;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError(form);
      var orderNumber = (form.elements['order_number'].value || '').trim();
      var emailInput = form.elements['email'];
      var phoneInput = form.elements['phone'];
      var email = emailInput ? (emailInput.value || '').trim() : '';
      var phone = phoneInput ? (phoneInput.value || '').trim() : '';

      if (!orderNumber) {
        showError(form, 'Ingresa el número de pedido.');
        return;
      }
      if (!email && !phone) {
        showError(form, 'Ingresa el email registrado en tu compra (o tu celular).');
        return;
      }

      var btn = $('button[type="submit"]', form);
      btn.disabled = true;
      btn.textContent = 'Buscando…';

      var payload = { order_number: orderNumber, parley_id: parleyId };
      if (email) payload.email = email;
      if (phone) payload.phone = phone;

      fetch(BACKEND_URL + '/get-predictions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          btn.disabled = false;
          btn.textContent = 'Ver mis marcadores';
          if (!res.json.ok) {
            showError(form, res.json.message || 'No encontramos tus marcadores.');
            track('mis_marcadores_not_found', { parley_id: parleyId, error_code: res.json.error_code });
            return;
          }
          renderMisMarcadores(res.json);
          track('mis_marcadores_view', { parley_id: parleyId, order_number: orderNumber });
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = 'Ver mis marcadores';
          showError(form, 'No pudimos contactar el servidor. Intenta de nuevo.');
          console.error(err);
        });
    });

    var resetBtn = document.querySelector('[data-mm-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        var formStep = document.querySelector('[data-step="consultar-form"]');
        var resultStep = document.querySelector('[data-step="consultar-result"]');
        if (formStep) formStep.hidden = false;
        if (resultStep) resultStep.hidden = true;
        form.reset();
      });
    }
  }

  function renderMisMarcadores(data) {
    var formStep = document.querySelector('[data-step="consultar-form"]');
    var resultStep = document.querySelector('[data-step="consultar-result"]');
    if (formStep) formStep.hidden = true;
    if (resultStep) resultStep.hidden = false;

    // Title
    var titleEl = $('[data-mm-title]', resultStep);
    if (titleEl) titleEl.textContent = 'Tus marcadores — ' + (data.parley?.name || '');

    // Customer + pedido
    var customerEl = $('[data-mm-customer]', resultStep);
    if (customerEl) customerEl.textContent = data.customer_name || '';
    var pedidoEl = $('[data-mm-pedido]', resultStep);
    if (pedidoEl) pedidoEl.textContent = 'Participación #' + (data.participation_id || '').slice(0, 8);
    var fechaEl = $('[data-mm-fecha]', resultStep);
    if (fechaEl && data.submitted_at) {
      var d = new Date(data.submitted_at);
      if (!isNaN(d.getTime())) {
        fechaEl.textContent = 'Registrado el ' + d.toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' });
      }
    }

    // Resumen de aciertos (si ya hay resultados)
    var resumen = $('[data-mm-resumen]', resultStep);
    var hasResults = data.results && data.results.correct_predictions != null;
    if (resumen) {
      resumen.hidden = !hasResults;
      if (hasResults) {
        $('[data-mm-aciertos]', resumen).textContent = data.results.correct_predictions + '/10';
        $('[data-mm-pct]', resumen).textContent = (data.results.reward_percentage ?? 0) + '%';
        var bonoVal = data.results.reward_value;
        if (bonoVal != null) {
          $('[data-mm-bono]', resumen).textContent = fmtMoney(parseFloat(bonoVal), 'COP');
        } else {
          $('[data-mm-bono]', resumen).textContent = '—';
        }
      }
    }

    // Lista de marcadores
    var listEl = $('[data-mm-list]', resultStep);
    var tpl = document.getElementById('parley-mm-match-template');
    if (listEl && tpl) {
      listEl.innerHTML = '';
      (data.predictions || []).forEach(function (p, idx) {
        var clone = tpl.content.cloneNode(true);
        $('.parley-mm-match__num', clone).textContent = (idx + 1);
        $('[data-mm-home-emoji]', clone).textContent = p.home_emoji || '';
        $('[data-mm-home-name]', clone).textContent = p.home_team || '';
        $('[data-mm-away-emoji]', clone).textContent = p.away_emoji || '';
        $('[data-mm-away-name]', clone).textContent = p.away_team || '';
        $('[data-mm-home-score]', clone).textContent = p.home_score;
        $('[data-mm-away-score]', clone).textContent = p.away_score;

        if (p.real_home_score != null && p.real_away_score != null) {
          var realEl = $('[data-mm-real]', clone);
          realEl.hidden = false;
          $('[data-mm-real-score]', realEl).textContent = p.real_home_score + ' - ' + p.real_away_score;
          var badge = $('[data-mm-badge]', realEl);
          if (p.home_score === p.real_home_score && p.away_score === p.real_away_score) {
            badge.textContent = '✓ Acierto';
            badge.className = 'parley-mm-match__badge parley-mm-match__badge--win';
          } else {
            badge.textContent = '✗ No acierto';
            badge.className = 'parley-mm-match__badge parley-mm-match__badge--lose';
          }
        }
        listEl.appendChild(clone);
      });
    }

    resultStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ============================================================
  // Leaderboard live — poll cada 30s, render lista de participantes
  // ============================================================
  function initLeaderboard() {
    var section = $('[data-leaderboard]');
    if (!section) return;
    var parleyId = section.getAttribute('data-parley-id') || 'fecha-1';
    var listEl = $('[data-lb-list]', section);
    var totalEl = $('[data-lb-total]', section);
    var tpl = document.getElementById('parley-lb-item-template');
    if (!listEl || !tpl) return;

    function colorFromName(name) {
      // hash simple para asignar un color de avatar consistente por participante
      var h = 0;
      for (var i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
      var hue = h % 360;
      return 'hsl(' + hue + ', 55%, 45%)';
    }
    function initials(name) {
      var parts = (name || '').trim().split(/\s+/);
      if (parts.length === 0 || !parts[0]) return '·';
      if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    }
    function relTime(iso) {
      var t = new Date(iso).getTime();
      if (isNaN(t)) return '';
      var diff = Math.max(0, Math.floor((Date.now() - t) / 1000));
      if (diff < 60) return 'hace ' + diff + 's';
      if (diff < 3600) return 'hace ' + Math.floor(diff / 60) + ' min';
      if (diff < 86400) return 'hace ' + Math.floor(diff / 3600) + ' h';
      return 'hace ' + Math.floor(diff / 86400) + ' d';
    }

    function render(data) {
      if (totalEl) totalEl.textContent = data.total ?? '0';
      if (!data.participants || data.participants.length === 0) {
        listEl.innerHTML = '<p class="parley-leaderboard__empty">Aún no hay participantes. ¡Sé el primero!</p>';
        return;
      }
      var ul = document.createElement('ul');
      ul.className = 'parley-leaderboard__ul';
      data.participants.forEach(function (p) {
        var clone = tpl.content.cloneNode(true);
        var avatar = $('[data-lb-avatar]', clone);
        avatar.textContent = initials(p.display_name);
        avatar.style.background = colorFromName(p.display_name);
        var nameEl = $('[data-lb-name]', clone);
        nameEl.textContent = p.display_name;
        // Tiempo relativo como subtítulo del nombre
        var rel = relTime(p.created_at);
        if (rel) {
          var span = document.createElement('span');
          span.className = 'parley-lb-item__time';
          span.textContent = rel;
          nameEl.appendChild(span);
        }
        var aciertosEl = $('[data-lb-aciertos]', clone);
        if (p.correct_predictions != null) {
          aciertosEl.textContent = p.correct_predictions + '/10';
          aciertosEl.classList.add('parley-lb-item__aciertos--filled');
        } else {
          aciertosEl.textContent = '—';
        }
        ul.appendChild(clone);
      });
      listEl.innerHTML = '';
      listEl.appendChild(ul);
    }

    function fetchData() {
      fetch(BACKEND_URL + '/leaderboard?parley_id=' + encodeURIComponent(parleyId))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) { if (data && data.ok) render(data); })
        .catch(function () { /* silent */ });
    }

    fetchData();
    setInterval(fetchData, 30000);
  }

  // ============================================================
  // SpotlightCard — efecto glow que sigue al cursor (sin React)
  // ============================================================
  function initSpotlightCards() {
    var cards = $$('[data-parley-spotlight]');
    if (!cards.length) return;

    // Detect touch device — en mobile el efecto no aporta; mostrar glow estático suave
    var isTouch = window.matchMedia && window.matchMedia('(hover: none)').matches;

    cards.forEach(function (card) {
      if (isTouch) {
        card.style.setProperty('--spotlight-opacity', '0.4');
        card.style.setProperty('--spotlight-x', '50%');
        card.style.setProperty('--spotlight-y', '30%');
        return;
      }

      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        card.style.setProperty('--spotlight-x', x + 'px');
        card.style.setProperty('--spotlight-y', y + 'px');
      });
      card.addEventListener('mouseenter', function () {
        card.style.setProperty('--spotlight-opacity', '0.85');
      });
      card.addEventListener('mouseleave', function () {
        card.style.setProperty('--spotlight-opacity', '0');
      });
      card.addEventListener('focusin', function () {
        card.style.setProperty('--spotlight-opacity', '0.85');
      });
      card.addEventListener('focusout', function () {
        card.style.setProperty('--spotlight-opacity', '0');
      });
    });
  }

  // ============================================================
  // Wire up
  // ============================================================
  function init() {
    var validateForm = $('[data-form="validate"]');
    if (validateForm) validateForm.addEventListener('submit', handleValidate);
    initSpotlightCards();
    initMisMarcadores();
    initLeaderboard();
    bootstrap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
